import { Component } from '@angular/core';
import { ActivityNotificationService } from '../activity-notification.service';

@Component({
  selector: 'lp2-activity-notification-list',
  templateUrl: './activity-notification-list.component.html',
  styleUrls: ['./activity-notification-list.component.scss'],
})
export class ActivityNotificationListComponent {
  constructor(
    public activityNotificationService: ActivityNotificationService
  ) {}
}



// WEBPACK FOOTER //
// ./ts/app/shared/activity-notification/activity-notification-list/activity-notification-list.component.ts